var $dc89fc3b4681385e$exports = {};
$dc89fc3b4681385e$exports = {
    "help": `Yard\u{131}m`,
    "info": `Bilgiler`
};


export {$dc89fc3b4681385e$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
